import { environment } from '@env/environment';
import { MenuItem } from '../models/menu/menu.model';
import { SecurityRoleKey } from '../models/security/security-role-keys';
import { menuItems } from './default-menu';
import { demoMenu } from './demo-menu';
import { getingeMenu } from './getinge-menu';
import { gmcaMenu } from './gmca-menu';
import { hfgMenu } from './hfg-menu';
import { joiffMenu } from './joiff-menu';
import { metMenu } from './met-menu';
import { mfrsMenu } from './mfrs-menu';
import { pepperMenu } from './pepper-menu';
import { pilotMenu } from './pilot-menu';
import { rbfrsMenu } from './rbfrs-menu';
import { stdaeroMenu } from './stdaero-menu';
import { vivoMenu } from './vivo-menu';

export let flattenRequiredSecurityRoles: {
  [key: string]: SecurityRoleKey[];
};

export function getMenu(): MenuItem[] {
  const menuSetting = environment.clientAccount.menu;
  let menu: MenuItem[];
  switch (menuSetting) {
    case 'demo':
      menu = constructedMenu(demoMenu);
      break;
    case 'pilot':
      menu = constructedMenu(pilotMenu);
      break;
    case 'hfg':
      menu = constructedMenu(hfgMenu);
      break;
    case 'gmca':
      menu = constructedMenu(gmcaMenu);
      break;
    case 'getinge':
      menu = constructedMenu(getingeMenu);
      break;
    case 'vivo':
      menu = constructedMenu(vivoMenu);
      break;
    case 'pepper':
      menu = constructedMenu(pepperMenu);
      break;
    case 'mfrs':
      menu = constructedMenu(mfrsMenu);
      break;
    case 'rbfrs':
      menu = constructedMenu(rbfrsMenu);
      break;
    case 'met':
      menu = constructedMenu(metMenu);
      break;
    case 'joiff':
      menu = constructedMenu(joiffMenu);
      break;
    case 'stdaero':
      menu = constructedMenu(stdaeroMenu);
      break;
    default: {
      menu = constructedMenu(menuItems);
      break;
    }
  }
  flattenRequiredSecurityRoles = flattenRoles(menu);
  return menu;
}

function constructedMenu(customMenu) {
  const fullMenu = [];
  menuItems.forEach((m) => {
    const customMenuItem = customMenu.find(
      (f: { routeIdentifier: string }) =>
        f.routeIdentifier === m.routeIdentifier,
    );
    const menuItem = Object.assign({}, m, customMenuItem);
    if (customMenuItem && customMenuItem.subMenu) {
      menuItem.subMenu = [];
      m.subMenu.forEach((sm) => {
        const cmi = customMenuItem.subMenu.find(
          (mis) => mis.routeIdentifier === sm.routeIdentifier,
        );
        const smi = Object.assign({}, sm, cmi);
        menuItem.subMenu.push(smi);
      });
    }

    fullMenu.push(menuItem);
  });
  return fullMenu;
}

function flattenRoles(menuItem: MenuItem[]) {
  const requiredSecurityRole = menuItem.reduce((m, r) => {
    if (r.routeIdentifier) {
      m[r.routeIdentifier] = r.securityRoles;
    }
    if (r.subMenu) {
      r.subMenu.reduce((m1, r1) => {
        if (r1.routeIdentifier) {
          m1[r1.routeIdentifier] = r1.securityRoles;
        }
        return m1;
      }, m);
    }
    return m;
  }, {});
  return requiredSecurityRole;
}
